/* eslint-disable folders/match-regex */

import { InvestmentKnowledgeQuestionnaire } from './types';

export const investmentKnowledgeQuestionnaire: InvestmentKnowledgeQuestionnaire =
  [
    {
      sectionNameKey: 'auth.signUp.steps.quizz.sections.goals.title', // Objectifs en matière d’investissement et profil de risque
      questions: [
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.goals.questions.mainGoal.title', // Quel est votre principal objectif de vos investissements sur la plateforme Sowefund ?
          type: 'radio',
          apiProperty: 'objectifInvestissements',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.mainGoal.values.precautionarySavings', // Constituer une épargne de précaution
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.mainGoal.values.economicDevelopment', // Soutenir le développement de l’économie
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.mainGoal.values.regularPassiveIncome', // Se constituer un revenu passif régulier
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.mainGoal.values.highReturn', // Rechercher un fort rendement
              value: 4,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.goals.questions.plannedDuration.title', // Quelle est la durée envisagée de vos placements sur la plateforme ?
          type: 'radio',
          apiProperty: 'dureePlacements',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.plannedDuration.values.lessThanTwoYears', // Inférieure à 2 ans
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.plannedDuration.values.twoToSevenYears', // Entre 2 ans et 7 ans
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.plannedDuration.values.moreThanSevenYears', // Supérieure à 7 ans
              value: 3,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.goals.questions.roiPreference.title', // Pour un investissement de 10 000 €, préférez-vous :
          type: 'radio',
          apiProperty: 'preferencePour10k',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.roiPreference.values.highReturnBigRisks', // 50% de chance de tout perdre et 50% de chance de récupérer 15 000 euros
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.roiPreference.values.smallReturnLowerRisks', // 50% de chance de récupérer 3 000 euros et 50% de chance de récupérer 12 000 euros
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.goals.questions.roiPreference.values.noPreference', // Pas de préférence
              value: 3,
            },
          ],
        },
      ],
    },
    {
      sectionNameKey:
        'auth.signUp.steps.quizz.sections.investmentExperience.title', // Expérience en matière d’investissement
      questions: [
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.title', // Etes-vous familier avec les instruments financiers suivants ?
          type: 'checkbox',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowListedShares', // Actions cotées
              apiProperty: 'knowListedShares',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowNonListedShares', // Actions non cotées
              apiProperty: 'knowNonListedShares',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowBonds', // Obligations
              apiProperty: 'knowObligations',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowProduitsDerivesComplexes', // Produits dérivés complexes
              apiProperty: 'knowProduitsDerivesComplexes',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowFcpr', // OPCVM, Fonds commun de placement, SICAV
              apiProperty: 'knowFcpr',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsKnowledge.values.knowAucunProduit', // Aucun
              apiProperty: 'knowAucunProduit',
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.title', // Sur quel type d’instrument financier avez-vous déjà investi ?
          type: 'checkbox',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneListedShares', // Actions cotées
              apiProperty: 'doneListedShares',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneNonListedShares', // Actions non cotées
              apiProperty: 'doneNonListedShares',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneBonds', // Obligations
              apiProperty: 'doneObligations',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneProduitsDerivesComplexes', // Produits dérivés complexes
              apiProperty: 'doneProduitsDerivesComplexes',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneFcpr', // OPCVM, Fonds commun de placement, SICAV
              apiProperty: 'doneFcpr',
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsAlreadyUsed.values.doneAucunProduit', // Aucun
              apiProperty: 'doneAucunProduit',
            },
          ],
        },
        {
          requirements: [
            {
              targetProperty: 'combienOperations',
              apiProperties: [
                {
                  apiProperty: 'doneListedShares',
                  value: true,
                },
                {
                  apiProperty: 'doneNonListedShares',
                  value: true,
                },
                {
                  apiProperty: 'doneObligations',
                  value: true,
                },
                {
                  apiProperty: 'doneProduitsDerivesComplexes',
                  value: true,
                },
                {
                  apiProperty: 'doneFcpr',
                  value: true,
                },
              ],
            },
          ],
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestmentCount.title', // Sur les 24 derniers mois, combien avez-vous réalisé d’opérations sur ces instruments financiers ?
          type: 'radio',
          apiProperty: 'combienOperations',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestmentCount.values.lessThanFive', // Moins de 5
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestmentCount.values.fiveToFifteen', // Entre 5 et 15
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestmentCount.values.moreThanFifteen', // Plus de 15
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestmentCount.values.zero', // Aucune opération
              value: 4,
            },
          ],
        },
        {
          requirements: [
            {
              targetProperty: 'montantInvesti',
              apiProperties: [
                {
                  apiProperty: 'combienOperations',
                  value: 1,
                },
                {
                  apiProperty: 'combienOperations',
                  value: 2,
                },
                {
                  apiProperty: 'combienOperations',
                  value: 3,
                },
              ],
            },
          ],
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestedAmount.title', // Sur les 24 derniers mois, quel montant avez-vous investi sur ces instruments financiers ?
          type: 'radio',
          apiProperty: 'montantInvesti',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestedAmount.values.lessThanFiveThousand', // Moins de 5 000 euros
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestedAmount.values.fiveToTenThousand', // Entre 5 000 et 10 000 euros
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsInvestedAmount.values.moreThanTenThousand', // Plus de 10 000 euros
              value: 3,
            },
          ],
        },
        {
          requirements: [
            {
              targetProperty: 'timeframeInvestments',
              apiProperties: [
                {
                  apiProperty: 'doneListedShares',
                  value: true,
                },
                {
                  apiProperty: 'doneNonListedShares',
                  value: true,
                },
                {
                  apiProperty: 'doneObligations',
                  value: true,
                },
                {
                  apiProperty: 'doneProduitsDerivesComplexes',
                  value: true,
                },
                {
                  apiProperty: 'doneFcpr',
                  value: true,
                },
              ],
            },
          ],
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.title', // Sur quelle période avez-vous réalisé les transactions d’investissement que vous avez déclarées ?',
          type: 'radio',
          apiProperty: 'timeframeInvestments',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.values.lessThanAYear', // Moins d’un an
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.values.betweenOneAndTwoYears', // Entre 1 et 3 ans
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.values.betweenTwoAndFiveYears', // Entre 3 et 5 ans
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.values.moreThanTenFiveYears', // Plus de 5 ans
              value: 4,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsTimeframeInvestments.values.never', // Jamais
              value: 5,
            },
          ],
        },
        {
          // Regulatory question — always shown regardless of investment experience
          labelKey:
            'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsHowLong.title', // Depuis combien de temps réalisez-vous des investissements (tous types confondus) ?
          type: 'radio',
          apiProperty: 'howLongInvestor',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsHowLong.values.lessThanAYear', // Moins d’un an
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsHowLong.values.betweenOneAndThreeYears', // Entre 1 et 3 ans
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsHowLong.values.betweenThreeAndFiveYears', // Entre 3 et 5 ans
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.investmentExperience.questions.financialInstrumentsHowLong.values.moreThanTenFiveYears', // Plus de 5 ans
              value: 4,
            },
          ],
        },
      ],
    },
    {
      sectionNameKey:
        'auth.signUp.steps.quizz.sections.startupInvestmentExperience.title', // Expérience en matière d’investissement en capital dans les startups
      questions: [
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.crowdfundingExperience.title', // Avez-vous déjà utilisé les services d’une plateforme de financement participatif ?
          type: 'radio',
          apiProperty: 'combienPlateformeFinancementParticipatif',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.crowdfundingExperience.values.lessThanFive', // Moins de 5 fois
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.crowdfundingExperience.values.fiveToTen', // Entre 5 et 10 fois
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.crowdfundingExperience.values.moreThanTen', // Plus de 10 fois
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.crowdfundingExperience.values.never', // Jamais
              value: 4,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.startupInvestmentCount.title', // Avez-vous déjà investit dans une startup ?
          type: 'radio',
          apiProperty: 'dejaInvestiStartup',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.startupInvestmentCount.values.once', // Une fois
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.startupInvestmentCount.values.twoToFive', // Entre 2 et 5 fois
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.startupInvestmentCount.values.moreThanFive', // Plus de 5 fois
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.startupInvestmentExperience.questions.startupInvestmentCount.values.never', // Jamais
              value: 4,
            },
          ],
        },
      ],
    },
    {
      sectionNameKey: 'auth.signUp.steps.quizz.sections.riskAwareness.title', // Connaissance des risques
      questions: [
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestInvestment.title', // Quel investissement comporte selon vous le plus de risques ?
          type: 'radio',
          apiProperty: 'investissementLePlusDeRisques',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestInvestment.values.startup', // Un investissement en action dans une startup
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestInvestment.values.cac40', // Un investissement en action dans une entreprise du CAC 40
              value: 2,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestStartupInvestment.title', // Quel investissement, dans une startup, comporte selon vous le plus de risques ?
          type: 'radio',
          apiProperty: 'startupLeplusDeRisques',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestStartupInvestment.values.action', // Un investissement en action
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.riskiestStartupInvestment.values.bond', // Un investissement en obligation
              value: 2,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.losses.title', // Lors d’un investissement en action sur une plateforme de financement participatif :
          type: 'radio',
          apiProperty: 'investissementEnActions',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.losses.values.none', // Vous êtes assuré de récupérer les sommes investies
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.losses.values.onlyDividends', // Vous pouvez perdre uniquement les dividendes de votre investissement
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.losses.values.all', // Vous pouvez perdre tout ou une partie de votre investissement (capital et dividendes)
              value: 3,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentRecovery.title', // En investissant sur la plateforme Sowefund, vous pouvez récupérer votre investissement quand vous le désirez ?
          type: 'radio',
          apiProperty: 'investissementRecuperation',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentRecovery.values.true', // Vrai
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentRecovery.values.false', // Faux
              value: 2,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialJobExperience.title', // Avez-vous déjà exercé une profession dans le domaine de la finance ?
          type: 'radio',
          apiProperty: 'professionFinance',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialJobExperience.values.yes', // Oui
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialJobExperience.values.no', // Non
              value: 2,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialEducation.title', // Avez-vous une formation dans les domaines économique ou financier ?
          type: 'radio',
          apiProperty: 'formationFinance',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialEducation.values.yes', // Oui
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.financialEducation.values.no', // Non
              value: 2,
            },
          ],
        },
        {
          labelKey:
            'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentPreferences.title', // Avez-vous des préférences en matière d'investissement durable ou responsable (critères ESG) ?
          type: 'radio',
          apiProperty: 'ESGPreferences',
          values: [
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentPreferences.values.yes', // Oui, les critères ESG sont essentiels à mes décisions d'investissement
              value: 1,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentPreferences.values.yes2', // Oui, les critères ESG comptent pour moi, sans en faire un critère absolu
              value: 2,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentPreferences.values.no', // Non, la durabilité n'est pas un critère déterminant dans mes choix d'investissement
              value: 3,
            },
            {
              labelKey:
                'auth.signUp.steps.quizz.sections.riskAwareness.questions.investmentPreferences.values.unqualified', // Je ne me sens pas suffisamment informé(e) pour répondre à cette question
              value: 4,
            },
          ],
        },
      ],
    },
  ];
